import React, {useState, useEffect} from "react";
import "./index.css";
import Loading from "../loading";
import jsondata from "./data.json";


function WorkDone(){

	let [data, setData] = useState([]);
	let [position, setposition] = useState(0); //position of current object within the 'data' state array
	let [ready, getReady] = useState(false);

	const moveBack = () =>{
		if(position > 0) setposition(position - 1) 
		//if position is greater than zero...move backwards by reducing positon
		else{setposition( data.length - 1 )}
		//else movebackwards by settingposition to the highest possible number
	}

	const moveUp = () =>{
		if (position < data.length - 1) setposition(position + 1)
		//if position is less than the total objects in the data array...move up by increasing the position
		else{setposition(0)} 
		//else moveup by settingposition to the first item again
	}

	useEffect(()=>{
		setData(jsondata);
		getReady(true);
	}, [])

	return(
		<article id='works' >

			<div className="wide-only">
			<p className="wide-only arts pleasing"> click on image for details </p>
			{
				!ready ? <Loading /> : <React.Fragment>
					<div className='frame'>

						<div className="mover leftward"> <i className="fa solid fa-arrow-left" onClick={()=>moveBack()}></i> </div>

						<div className='bar'>

							<img src={data[position].image} alt={data[position].context.substr(0, 19)} loading="lazy" />
						
							<p onClick={(e)=>e.target.classList.toggle('showup')} >
								{data[position].context}
							</p>

						</div>

						<div className="mover rightward"> <i className="fa solid fa-arrow-right" onClick={()=>moveUp()}></i> </div>				
					</div>

					<a href={data[position].link} className='sedated' target="_blank" rel="noreferrer"> View Live </a>
				</React.Fragment>	
			}
			</div>
		

			<p className='pleasing'>
				I have worked with different people on different projects ranging from open source python (or Javascript)
				scripts to large backend and API development for both mobile applications and full web based application.
			</p>
			<p className="tiny-only arts pleasing"> tap image for details </p>
			<div className="tiny-only">				
					{
						!ready ? <Loading /> : data.map((d, ind)=>{
							return(
								<div className="wooden" key={ind} data-aos="zoom-in-up" data-aos-duration="1500">
									<div className="imagine"> <img src={d.image} alt={d.context.substr(0, 19)} loading="lazy" /> </div>
									<a href={d.link} className='sedated' target="_blank" rel="noreferrer"> View Live </a>
									<div className="sight" onClick={(e)=>e.target.classList.toggle("lightup")}>
										<p className="noclass"> {d.context} </p>
									</div>
								</div>									
								)
						})

					}					
			</div>

		</article>

		)
};

export default WorkDone;